import { render, staticRenderFns } from "./ContestTableTab.vue?vue&type=template&id=cbda9ed8&scoped=true&"
import script from "./ContestTableTab.vue?vue&type=script&lang=js&"
export * from "./ContestTableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbda9ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VPagination})
